module.exports = __webpack_public_path__ + "static/media/fa-regular-400.6493321d.eot";